


import {UserType} from './UserType'; 
export class MessagePartyVM {
    
    userType?: UserType;
    
    userId?: string;
    
    name?: string;
    
    profileImage?: string;
    
}
